// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertyIdBuf } from '../entity/entity-property-id-buf.js';
import { PropertyColor } from '../interface/property-color.js';
import { PropertySize } from '../interface/property-size.js';


/**
 * The settings for an individual property within the view mode panel.
 * This can be tied to either a real property, or a virtual property,
 * or eventually to a custom field.
 */
export class ViewModeShowBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ViewModeShowBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsViewModeShowBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeShowBuf):ViewModeShowBuf {
  return (obj || new ViewModeShowBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsViewModeShowBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeShowBuf):ViewModeShowBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ViewModeShowBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

propertyId(obj?:EntityPropertyIdBuf):EntityPropertyIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new EntityPropertyIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

size():PropertySize {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt8(this.bb_pos + offset) : PropertySize.Medium;
}

color():PropertyColor {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : PropertyColor.Default;
}

/**
 * The scale parameter is for properties that have a flexible size
 * constraint, namely the icon/preview
 */
scale():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null;
}

static startViewModeShowBuf(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addPropertyId(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, propertyIdOffset, 0);
}

static addSize(builder:flatbuffers.Builder, size:PropertySize) {
  builder.addFieldInt8(1, size, PropertySize.Medium);
}

static addColor(builder:flatbuffers.Builder, color:PropertyColor) {
  builder.addFieldInt8(2, color, PropertyColor.Default);
}

static addScale(builder:flatbuffers.Builder, scale:number) {
  builder.addFieldFloat32(3, scale, null);
}

static endViewModeShowBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createViewModeShowBuf(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset, size:PropertySize, color:PropertyColor, scale:number|null):flatbuffers.Offset {
  ViewModeShowBuf.startViewModeShowBuf(builder);
  ViewModeShowBuf.addPropertyId(builder, propertyIdOffset);
  ViewModeShowBuf.addSize(builder, size);
  ViewModeShowBuf.addColor(builder, color);
  if (scale !== null)
    ViewModeShowBuf.addScale(builder, scale);
  return ViewModeShowBuf.endViewModeShowBuf(builder);
}
}
